// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H2V2H22V22ZM12 15.5L16.25 10H7.75L12 15.5Z"}}]};

const ChevronDownRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-down-rectangle-filled',
    ref,
    icon: element,
  },
));

ChevronDownRectangleFilledIcon.displayName = 'ChevronDownRectangleFilledIcon';

export default ChevronDownRectangleFilledIcon;
